import script from "./new-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./new-detail.vue?vue&type=script&setup=true&lang=js"

import "./new-detail.vue?vue&type=style&index=0&id=486eab10&lang=less&scoped=true"

import exportComponent from "/Users/xyyw/code/company/web/sanroe-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-486eab10"]])

export default __exports__